import service from '@/store/services/rating-service';

const state = {
    ratingData: {},
    proRetoucherRatingData:{},
    proRetoucherNotificationData:{},
    adminRatingData: {},
    adminCommonRatingData: {},
    adminCommonRatingDataUsers: {},
    financeData: {},
};

const mutations = {
    SET_RATING_DATA: (state, ratingData) => {
        state.ratingData = ratingData;
    },
    SET_PRO_RETOUCHER_RATING_DATA: (state, proRetoucherRatingData) => {
        state.proRetoucherRatingData = proRetoucherRatingData;
    },
    SET_PRO_RETOUCHER_NOTIFICATION_DATA: (state, proRetoucherNotificationData) => {
        state.proRetoucherNotificationData = proRetoucherNotificationData;
    },
    SET_ADMIN_RATING_DATA: (state, adminRatingData) => {
        state.adminRatingData = adminRatingData;
    },
    SET_ADMIN_COMMON_RATING_DATA: (state, adminCommonRatingData) => {
        state.adminCommonRatingData = adminCommonRatingData;
    },
    SET_ADMIN_COMMON_RATING_DATA_USERS: (state, adminCommonRatingDataUsers) => {
        state.adminCommonRatingDataUsers = adminCommonRatingDataUsers;
    },
    SET_FINANCE_DATA: (state, financeData) => {
        state.financeData = financeData;
    },
};

const actions = {

    ratingData({commit, dispatch}, params) {
        return service.ratingData(params)
            .then(({ratingData}) => {
                commit('SET_RATING_DATA', ratingData);
            });
    },
    proRetoucherRatingData({commit, dispatch}, params) {
        return service.proRetoucherRatingData(params)
            .then(({proRetoucherRatingData}) => {
                commit('SET_PRO_RETOUCHER_RATING_DATA', proRetoucherRatingData);
            });
    },
    proRetoucherNotificationData({commit, dispatch}, params) {
        return service.proRetoucherNotificationData(params)
            .then(({proRetoucherNotificationData}) => {
                commit('SET_PRO_RETOUCHER_NOTIFICATION_DATA', proRetoucherNotificationData);
            });
    },
    adminRatingData({commit, dispatch}, params) {
        return service.adminRatingData(params)
            .then(({adminRatingData}) => {
                commit('SET_ADMIN_RATING_DATA', adminRatingData);
            });
    },
    adminCommonRatingData({commit, dispatch}, params) {
        return service.adminCommonRatingData(params)
            .then(({adminCommonRatingData}) => {
                commit('SET_ADMIN_COMMON_RATING_DATA', adminCommonRatingData);
            });
    },
    adminCommonRatingDataUsers({commit, dispatch}, params) {
        return service.adminCommonRatingDataUsers(params)
            .then(({adminCommonRatingDataUsers}) => {
                commit('SET_ADMIN_COMMON_RATING_DATA_USERS', adminCommonRatingDataUsers);
            });
    },
    financeData({commit, dispatch}, params) {
        return service.financeData(params)
            .then(({financeData}) => {
                commit('SET_FINANCE_DATA', financeData);
            });
    },
};

const getters = {
    ratingData: state => state.ratingData,
    proRetoucherRatingData: state => state.proRetoucherRatingData,
    proRetoucherNotificationData: state => state.proRetoucherNotificationData,
    adminRatingData: state => state.adminRatingData,
    adminCommonRatingData: state => state.adminCommonRatingData,
    adminCommonRatingDataUsers: state => state.adminCommonRatingDataUsers,
    financeData: state => state.financeData,
};

const rating = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
export default rating;